import { App } from 'vue'
import BTabs from './BTabs';

const components = [
  BTabs
]
const install = (app: App): void => {
  components.forEach(component => {
    component.install(app)
  })
}
const index = {
  install
}
export default index
